import request from '@/utils/request'

/**
 * 获取登录手机验证码
 */
export function getCode (phone, areaCode, imageCode, uuid) {
  return request({
    url: '/deliver/v1/getCode',
    method: 'post',
    data: { phone: phone, areaCode: areaCode, imageCode: imageCode, uuid: uuid }
  })
}

/**
 * 登录
 */
export function login (phone, code, areaCode, imageCode, uuid) {
  return request({
    url: '/deliver/v1/user/login',
    method: 'post',
    data: { phone: phone, code: code, areaCode: areaCode, imageCode: imageCode, uuid: uuid }
  })
}

/**
 * 邮箱登录
 */
export function loginOnEmail (email, code, imageCode, uuid) {
  return request({
    url: '/deliver/v1/user/loginOnEmail',
    method: 'post',
    data: { email, code, imageCode, uuid }
  })
}

/**
 * 微信登录
 */
export function loginByWechat (code) {
  return request({
    url: '/v1/app/interview-room/login/wechat_html_login',
    method: 'post',
    data: { code },
    // 登录接口在未登录态下调用，401 不应触发全局"登录过期"弹窗，交由调用方处理
    skipGlobalAuth: true
  })
}

/**
 * 绑定手机号-验证码获取
 */
export function getMsgCode (mobile, imageCode, uuid) {
  return request({
    url: '/deliver/v1/CheckPhoneGetCode',
    method: 'post',
    data: { phone: mobile, areaCode: '+86', imageCode, uuid }
  })
}

/**
 * 面试间发送验证码
 */
export function getInterviewMsgCode (mobile) {
  return request({
    url: '/v1/app/interview-room/login/bind_mobile_send_msg',
    method: 'post',
    data: {mobile}
  })
}

/**
 * 校验手机号是否绑定过微信
 */
export function checkMobile (data) {
  return request({
    url: '/v1/app/interview-room/login/check_open_id_by_phone',
    method: 'post',
    data
  })
}

/**
 * 面试间绑定手机号
 */
export function bindInterviewMobile (code, openId, phone) {
  return request({
    url: '/v1/app/interview-room/login/bind_mobile',
    method: 'post',
    data: { smsCode:code, openId, mobile:phone }
  })
}

/**
 * 绑定手机号
 */
export function bindMobile (mobile, phoneCode, imageCode, uuid) {
  return request({
    url: '/user-client/v1/userResume/phone',
    method: 'post',
    data: { phone: mobile, areaCode: '+86', code: phoneCode, imageCode, uuid }
  })
}

/**
 * 邮箱首次登录绑定手机号
 */
export function firstBindPhoneByEmail (phone, code, areaCode, imageCode, uuid) {
  return request({
    url: '/user-client/v1/userResume/firstBindPhoneByEmail',
    method: 'post',
    data: { phone, code, areaCode, imageCode, uuid }
  })
}

/**
 * 微信登录绑定手机号
 */
export function wechatBindPhone (code, openId, phone, areaCode) {
  return request({
    url: '/deliver/v1/auth/wechat/bindPhone',
    method: 'post',
    data: { code, openId, phone, areaCode },
    // 绑定阶段 token 可能处于未完成状态，4003 不能触发全局"登录过期"弹窗，
    // 交由 bindMobile.vue 自行处理（停留在绑定页提示重试）
    skipGlobalAuth: true
  })
}

/**
 * 获取用户信息
 */
export function getUserInfo (recruitmentCategory) {
  return request({
    url: '/user-client/v1/userInfo',
    method: 'get',
    params: { recruitmentCategory }
  })
}

/**
 * 用户注销
 */
export function logout (token) {
  return request({
    url: '/deliver/v1/user/logout',
    method: 'post',
    data: { token: token }
  })
}

/**
 * 更换手机号获取验证码
 */
export function getCheckPhoneCode (phone, areaCode, imageCode, uuid ) {
  return request({
    url: '/deliver/v1/CheckPhoneGetCode',
    method: 'post',
    data: { phone, areaCode, imageCode, uuid }
  })
}

/**
 * 更换手机号，验证手机号接口
 */
export function postCheckPhone (phone, areaCode, code) {
  return request({
    url: '/deliver/v1/CheckPhone',
    method: 'post',
    data: { phone: phone, areaCode: areaCode, code: code }
  })
}

/**
 * 更换手机号接口
 */
export function postUpdatePhone ( phone, areaCode, code, imageCode, uuid ) {
  return request({
    url: '/user-client/v1/userResume/phone',
    method: 'post',
    data: { phone, areaCode, code, imageCode, uuid }
  })
}

/**
 * 更换邮箱号 邮箱号获取验证码
 */
export function getCheckEmailCode (email, imageCode, uuid) {
  return request({
    url: '/deliver/v1/CheckEmailGetCode',
    method: 'post',
    data: { email, imageCode, uuid, }
  })
}

/**
 * 更换邮箱号，验证邮箱号
 */
export function postCheckEmail (email, code) {
  return request({
    url: '/deliver/v1/CheckEmail',
    method: 'post',
    data: { email: email, code: code }
  })
}

/**
 * 更换邮箱号接口
 */
export function postUpdateEmail (email, emailCode, imageCode, uuid ) {
  return request({
    url: '/user-client/v1/userResume/email',
    method: 'post',
    data: { email, emailCode, imageCode, uuid }
  })
}


/**
 * 获取图形验证码
 */
export function getCaptchalCode () {
  return request({
    url: '/deliver/v1/GetCaptcha',
    method: 'post',
    data: {}
  })
}

/**
 * 验证图形验证码
 */
export function postVerifyCaptcha (uuid, code) {
  return request({
    url: '/deliver/v1/VerifyCaptcha',
    method: 'post',
    data: { uuid: uuid, code: code }
  })
}

/**
 * 验证about文章
 */
export function getAboutTwitter () {
  return request({
    url: '/v1/portal/twitter',
    method: 'get',
  })
}

/**
 * 刷新token
 */
export function refreshToken () {
  return request({
    url: '/deliver/v1/user/refreshToken',
    method: 'post',
    data: {},
    // 绑定手机号后调用 refreshToken 可能因旧 token 已被作废而返回 401，
    // 此处静默失败交由调用方处理，避免触发全局"登录过期"弹窗打断绑定流程
    skipGlobalAuth: true
  })
}